import type {Course, CourseAccessDisabledWindow, CourseAccessScope} from './Course'

export function getActiveCourseAccessDisabledWindow(
  course: Course,
  scope: CourseAccessScope = 'course',
  now: Date = new Date()
): CourseAccessDisabledWindow | undefined {
  const nowMillis = now.getTime()
  return course.access_disabled_windows?.find(window => {
    const windowScope = window.scope ?? 'course'
    return (windowScope === 'course' || windowScope === scope) &&
      window.starts_at.toDate().getTime() <= nowMillis &&
      nowMillis < window.ends_at.toDate().getTime()
  })
}

export function isCourseArchived(course: Course): boolean {
  return course.status === 'archived'
}
